import {idtype, squareImage, linkTo, link, fieldLinkTo} from "querypieces";

export default `
  ...on pageBuilder_subscribeDownload_BlockType {
    ${idtype}
    label
    heading
    plainText
    ${squareImage}
    subscribeSource
    subscribeTargetAudience
    subscribeTheme
    download: ${fieldLinkTo}
    subscribeSuccessHeading
    subscribeSuccessText
    ctaText
  }
`;
